export const firstLetterToUppercase = (value: string) => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const suffixNum = (n: number) =>
  ["st", "nd", "rd"][((((n + 90) % 100) - 10) % 10) - 1] || "th";
